import React, { Component } from 'react';
import WebSubsection from './WebSubsection';

export default class WebSection extends Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (
            //row when tablet or pc, column when phone 
            <div>
                <div id={this.props.webSection.title }>
                    {this.props.webSection.title}
                </div>
                <div >
                    {this.props.webSection.webSubSections.map((webSubsection) =>
                        <WebSubsection
                            webSubsection={webSubsection}
                            
                        />)}
                </div>
            </div>

        );
    }

}